import { render } from "./Playlists.vue?vue&type=template&id=54f1d0b1"
import script from "./Playlists.vue?vue&type=script&lang=js"
export * from "./Playlists.vue?vue&type=script&lang=js"
script.render = render

export default script